import { render, staticRenderFns } from "./ConfigurationsView.vue?vue&type=template&id=0515901a&"
import script from "./ConfigurationsView.vue?vue&type=script&lang=js&"
export * from "./ConfigurationsView.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationsView.vue?vue&type=style&index=0&id=0515901a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports